export const UrlParamsKeys = {
    SHORTS: 's',
    CHECKOUT: 'j',
    VIDEO: 'v',
    CHAPTER_TIMESTAMP: 't',
    EXISTING_USER: 'existingUser',
};
